import React from 'react'
import Script from 'next/script'
import useGlobalPrivacyControl from "Hooks/useGlobalPrivacyControl";

const CrispChat = () => {
    return (
        <Script enableOnlyOnNextFrontEnd={true} id={'crispchat'} data-testid={'crispchat'} strategy={'afterInteractive'}>
            {`
            if(!window.$crisp){
                window.$crisp = [];
                window.CRISP_WEBSITE_ID = "771bf07e-1992-4611-811f-e95e9c8b4a99";
                (function () {
                    d = document;
                    s = d.createElement("script");
                    s.src = "https://client.crisp.chat/l.js?cacheBust=1";
                    s.async = 1;
                    d.getElementsByTagName("head")[0].appendChild(s);
                })();
            }
            window.CRISP_READY_TRIGGER = function() {
    
                $crisp.push(["config", "container:index", [100]]);

                $crisp.push(["on", "chat:initiated", function(){
                    try{
                        analytics.track('Chat Initiated', {
                            widget: 'Crisp'
                        });
                    }
                    catch(e){
                        console.error("Could not send chat Segment event");
                    }
                }]);

                $crisp.push(["on", "chat:opened", function(){
                    try{
                        ga('send', 'event', 'Chat', 'Chat opened');
                    }
                    catch(e){
                        console.error("Could not send chat GA event");
                    }
                    try{
                        analytics.track('Chat Opened', {
                            widget: 'Crisp'
                        });
                    }
                    catch(e){
                        console.error("Could not send chat Segment event");
                    }
                    window.chatOpenCallback();
                }]);

                $crisp.push(["on", "session:loaded", function () {
                    const crispChatbox = document.querySelector(".cc-unoo");
                    crispChatbox.id = "crisp-override"; 
                }]);

                $crisp.push(["on", "chat:closed", function(){
                    try{
                        ga('send', 'event', 'Chat', 'Chat closed');
                    }
                    catch(e){
                        console.error("Could not send chat GA event");
                    }
                    try{
                        analytics.track('Chat Closed', {
                            widget: 'Crisp'
                        });
                    }
                    catch(e){
                        console.error("Could not send chat Segment event");
                    }
                }]);

                $crisp.push(["on", "message:sent", function(){ 
                    try{
                        ga('send', 'event', 'Chat', 'Message Sent');
                    }
                    catch(e){
                        console.error("Could not send chat GA event");
                    }
                    try{
                        analytics.track('Chat Message Sent', {
                            widget: 'Crisp'
                        });
                    }
                    catch(e){
                        console.error("Could not send chat Segment event");
                    }
                }]);
                
                $crisp.push(["on", "message:received", function(){
                    try{
                        ga('send', 'event', 'Chat', 'Message Received');
                    }
                    catch(e){
                        console.error("Could not send chat GA event");
                    }
                    try{
                        analytics.track('Chat Message Received', {
                            widget: 'Crisp'
                        });
                    }
                    catch(e){
                        console.error("Could not send chat Segment event");
                    }
                }]);

                $crisp.push(["on", "user:email:changed", function(event){
                    try{
                        ga('send', 'event', 'Chat', 'Visitor Email Added');
                    }
                    catch(e){
                        console.error("Could not send chat GA event");
                    }
                    try{
                        analytics.identify(
                            {
                                "email": event
                            }, 
                            {
                                "context": {
                                    "traits": {
                                        "email": event
                                    }
                                }
                            });
                    }
                    catch(e){
                        console.error("Could not send chat Segment identify");
                    }

                    try{
                        analytics.track('Chat Email Changed', {
                            widget: 'Crisp'
                        });
                    }
                    catch(e){
                        console.error("Could not send chat Segment event");
                    }

                    try{
                        analytics.track('Chat Session Started', {
                            widget: 'Crisp'
                        });
                    }
                    catch(e){
                        console.error("Could not send chat Segment event");
                    }
                }]);

            };`}
        </Script>
    )
}

export default CrispChat